import React, { useEffect, useState } from 'react';
import { ICONS } from '../../constants/imageConstants';

const ImageZoomModal = ({ isOpen, onClose, imageUrl }) => {
  const [show, setShow] = useState(false);
  const isDefaultAvatar = imageUrl === ICONS.USER_AVATAR;

  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => setShow(true), 10);
      return () => clearTimeout(timer);
    } else {
      setShow(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 transition-all duration-300 ease-in-out ${
        show ? 'bg-black/70 backdrop-blur-sm' : 'bg-transparent backdrop-blur-none'
      }`}
      onClick={onClose}
    >
      <div
        className={`relative transition-all duration-300 ease-in-out ${
          show ? 'scale-100 opacity-100' : 'scale-90 opacity-0'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="w-[80vw] h-[80vw] max-w-[400px] max-h-[400px] lg:max-w-[320px] lg:max-h-[320px] bg-gray-100 rounded-full shadow-2xl border-4 border-white/80 flex items-center justify-center overflow-hidden">
          <img
            src={imageUrl}
            alt="Profile"
            className={isDefaultAvatar ? "w-3/4 h-3/4 object-contain" : "w-full h-full object-cover"}
          />
        </div>
        <button
          onClick={onClose}
          className={`absolute -top-2 -right-2 p-2 rounded-full bg-white/90 text-gray-800 hover:bg-white transition-all duration-300 z-10 shadow-lg ${
            show ? 'scale-100 opacity-100' : 'scale-0 opacity-0'
          }`}
          aria-label="Close"
          style={{ transitionDelay: '150ms' }}
        >
          <img src={ICONS.CLOSE} alt="Close" className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ImageZoomModal;